var map = {
  "./da.json": [
    "41496",
    [
      24641
    ]
  ],
  "./fi.json": [
    "10250",
    [
      29911
    ]
  ],
  "./sv.json": [
    "65258",
    [
      79127
    ]
  ],
  "./ja.json": [
    "69070",
    [
      82371
    ]
  ],
  "./lt.json": [
    "92591",
    [
      62756
    ]
  ],
  "./sl.json": [
    "33616",
    [
      78569
    ]
  ],
  "./fr.json": [
    "2547",
    [
      144
    ]
  ],
  "./es.json": [
    "37485",
    [
      34892
    ]
  ],
  "./no.json": [
    "58332",
    [
      18573
    ]
  ],
  "./cs.json": [
    "68433",
    [
      83466
    ]
  ],
  "./en.json": [
    "35536",
    [
      1033
    ]
  ],
  "./description/en.json": [
    "25583",
    [
      17348
    ]
  ],
  "./pl.json": [
    "81835",
    [
      6712
    ]
  ],
  "./hu.json": [
    "14856",
    [
      68209
    ]
  ],
  "./nl.json": [
    "42761",
    [
      97906
    ]
  ],
  "./de.json": [
    "15828",
    [
      60341
    ]
  ],
  "./pt.json": [
    "80355",
    [
      93952
    ]
  ],
  "./it.json": [
    "32558",
    [
      45571
    ]
  ],
  "./et.json": [
    "52778",
    [
      70743
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 79714;
module.exports = __rspack_async_context;
